import React from 'react'

import getStrings from 'getStrings'
import getLanguage from 'getLanguage'


class TeacherSignUpGuideReviews extends React.Component {
    render() {
        const strings = getStrings()
        const lang = getLanguage()

        return (
            <section className='schoolzone-guide-reviews'>
                <div className='container'>
                    <div className='guide flex-row justify-around'>
                        <div className='guide--text'>
                          <h1 className='inline-block bg-orange rounded-border-2 text-white margin-bottom-none'>{strings.TEACHER_GUIDE_AND_REVIEWS_TITLE}</h1>
                          <h2>{strings.TEACHER_GUIDE_AND_REVIEWS_P1}</h2>
                          <p>{strings.TEACHER_GUIDE_AND_REVIEWS_P2}</p>
                        </div>
                        <a href={strings.TEACHER_GUIDE_LINK} className='guide--link'>
                          <img src={lang === 'en' ? '/images/GuideIcon_EN.png' : '/images/GuideIcon_FR.png'} alt={strings.TEACHER_GUIDE_IMG_ALT} />
                          <span className='block margin-top-1'>{strings.TEACHER_GUIDE_CTA_TEXT}</span>
                        </a>
                    </div>
                    <div className='reviews flex-row align-stretch justify-center'>
                      <div className='reviews--item'>
                          <img src={'/images/5stars.png'} alt='5 stars' />
                          <h2>{strings.TEACHER_REVIEWS_1_CREDIT}</h2>
                          <p className='margin-bottom-none'>{strings.TEACHER_REVIEWS_1_TEXT}</p>
                      </div>
                      <div className='reviews--item'>
                          <img src={'/images/5stars.png'} alt='5 stars' />
                          <h2>{strings.TEACHER_REVIEWS_2_CREDIT}</h2>
                          <p className='margin-bottom-none'>{strings.TEACHER_REVIEWS_2_TEXT}</p>
                      </div>
                      <div className='reviews--item'>
                          <img src={'/images/5stars.png'} alt='5 stars' />
                          <h2>{strings.TEACHER_REVIEWS_3_CREDIT}</h2>
                          <p className='margin-bottom-none'>{strings.TEACHER_REVIEWS_3_TEXT}</p>
                      </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default TeacherSignUpGuideReviews
